import { render } from "./ShowcaseGallery.vue?vue&type=template&id=3af12101"
import script from "./ShowcaseGallery.vue?vue&type=script&lang=js"
export * from "./ShowcaseGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__